import { SubscriptionTiers } from '@pec/aion-ui-core/enums/Subscription';
import { IMainSubscription } from '@pec/aion-ui-core/interfaces/mainSubscription';
import { OperationType } from '../types/enums';
import { schema as foundationSchema } from '../../foundation/schema';
import { schema as upgradeSchema } from '../../upgrade/schema';
import { schema as membershipChangeSchema } from '../../scopeChange/schema';
import { schema as renewSchema } from '../../renew/schema';

export const checkFoundation = (subscription: string) =>
  subscription === SubscriptionTiers.Foundation ||
  new URLSearchParams(window.location.search).get('foundation') === 'true';

export const getSurveyConfig = (operationType: OperationType, mainSubscription: IMainSubscription) => {
  const foundationFlow = checkFoundation(mainSubscription?.description);

  switch (operationType) {
    case OperationType.Upgrade: {
      if (foundationFlow) {
        return {
          surveySchema: foundationSchema,
          operationType: OperationType.Upgrade
        };
      }
      return {
        surveySchema: upgradeSchema,
        operationType: OperationType.Upgrade
      };
    }
    case OperationType.ScopeChange: {
      return {
        surveySchema: membershipChangeSchema,
        operationType: OperationType.ScopeChange
      };
    }
    case OperationType.Renew: {
      return {
        surveySchema: renewSchema,
        operationType: OperationType.Renew
      };
    }
    default:
      return {
        surveySchema: upgradeSchema,
        operationType: OperationType.Upgrade
      };
  }
};

export const isEmpty = (value: number) => value === null || value === undefined;
